import type { LocalCalendarEntry } from 'owa-graph-schema';
import { delete_0 } from 'owa-locstrings/lib/strings/delete_0.locstring.json';
import { deleteCalendarConfirmationTitleText } from 'owa-locstrings/lib/strings/deletecalendarconfirmationtitletext.locstring.json';
import { deleteCalendarConfirmationSubText } from 'owa-locstrings/lib/strings/deletecalendarconfirmationsubtext.locstring.json';
import { remove_0 } from 'owa-locstrings/lib/strings/remove_0.locstring.json';
import { removeCalendarConfirmationTitleText } from 'owa-locstrings/lib/strings/removecalendarconfirmationtitletext.locstring.json';
import { removeCalendarConfirmationSubText } from 'owa-locstrings/lib/strings/removecalendarconfirmationsubtext.locstring.json';
import { getUserMailboxInfo } from 'owa-client-ids';
import CalendarFolderTypeEnum from 'owa-service/lib/contract/CalendarFolderTypeEnum';
import { getOWAConnectedAccounts } from 'owa-accounts-store';

export function getRemoveDeleteConfirmationText(calendarEntry: LocalCalendarEntry | undefined) {
    const showDelete = calendarEntry ? shouldShowDelete(calendarEntry) : false;

    const confirmationText = {
        title: showDelete
            ? deleteCalendarConfirmationTitleText
            : removeCalendarConfirmationTitleText,
        subtext: showDelete ? deleteCalendarConfirmationSubText : removeCalendarConfirmationSubText,
        label: showDelete ? delete_0 : remove_0,
    };

    return confirmationText;
}

export function shouldShowDelete(calendarEntry: LocalCalendarEntry) {
    const allAccounts = [
        getUserMailboxInfo().userIdentity,
        ...getOWAConnectedAccounts().map(account => account.userIdentity),
    ];

    //Current showing delete in the confirmation dialog only for secondary calendars in primary account as well as connected accounts
    return (
        allAccounts.some(account => account === calendarEntry.SharedOwnerEmailAddress) &&
        calendarEntry.CalendarFolderType === CalendarFolderTypeEnum.None &&
        calendarEntry.__typename === 'LocalCalendarEntry'
    );
}
